import React, { Component } from 'react';
import DirectUpload from '../DirectUpload/DirectUpload'
import PropTypes from 'prop-types'; 
import InfoBlock from '../../Components/InfoBlock/InfoBlock'
import RLDD from 'react-list-drag-and-drop/lib/RLDD'; 
import { BiSort } from 'react-icons/bi';
import {Rest, backend_url} from "../../Helpers/Rest" 

export default class Uploads extends Component {
    state = {
        queue: [],
        uploads: [],
        loading_file: false,
        items: [{id: 1,},{id: 2},{id: 3}]
    }

    addToUpload = (files) =>{
        console.log(files)
        let q = this.state.queue
        q = q.concat(Array.from(files))
        this.setState({
            queue: q,
            loading_file: q[0]
        })
        
    }

    onSuccess = (file)=>{
        let queue = this.state.queue
        let index = queue.indexOf(file)
        queue.splice(index, 1) 
        this.setState({
            queue: queue,
            loading_file: false
            },
            ()=>{ 
                var max = this.props.max || 1  
                console.log(max, this.state.uploads.length)
                if(max>this.state.uploads.length+1){
                    this.setState({ 
                        loading_file: queue[0]
                    })
                }else{
                    this.setState({ 
                        queue: []
                    })
                }
                this.getUploads()
                }
            ) 
        
    }

    getUploads = ()=>{
        let rest = new Rest(this)
        rest.request('uploads', 'GET', {variant:this.props.variant, record_id: this.props.record_id, table_name: this.props.table_name, base64: this.props.base64, imageSize: 200}, (res)=>{
            this.setState({
                uploads: res
            })
            this.props.returnUploads && this.props.returnUploads(res)
        } )
    }



    componentDidMount = () => {
        this.getUploads()  
    };

    delete = (id) => {
        if(this.props.readonly){
            return
        }
        let rest = new Rest(this)
        rest.request('uploads', 'DELETE', {id: id}, (res)=>{
            this.getUploads()
        })
    }
    
    download = (f) => {
        let rest = new Rest(this)
        this.setState({
            ['loading_'+f.filename]: true
        })
        rest.get_file('uploads/'+f.id, {download: true}, f.filename, (res)=>{ 
            this.setState({
                ['loading_'+f.filename]: false
            })
        }) 
    }
  
    openImage = (f) => { 
        var image = new Image();
        image.src = "data:"+f.mimetype+";base64,"+f.base64 
        var w = window.open("");
        w.document.write(image.outerHTML); 
    }

    _render_as_file = (f, index)=>{
        return( 
                <div className="mt-2"> 
                    <span className="mr-3">{this.props.sortable? <BiSort size={18} title="edit" /> : "#"} {f.position}</span>
                    <span className="btn btn-outline-primary m-1" onClick={()=>this.download(f)}>{ this.state['loading_'+f.filename] ? "Downloading" : "Download "+f.filename } </span>
                    { !this.props.readonly && <span className="btn btn-outline-danger m-1" onClick={()=>this.delete(f.id)}>DELETE</span>}
                </div> 
        )
    }

    _render_as_image = (f, index)=>{
        var url = "data:"+f.mimetype+";base64,"+f.base64
        return ( 
                <div className="mt-2">
                    <span className="mr-3">{this.props.sortable? <BiSort size={18} title="edit" /> : "#"} {f.position}</span>
                        <img src={url} height={100} className="pointer" onClick={()=>this.openImage(f)}/> 
                    { !this.props.readonly && <span className="btn btn-outline-danger m-1" onClick={()=>this.delete(f.id)}>DELETE</span>}
                </div> 
        )
    }

    handleRLDDChange = (newItems)=>{
        this.setState({
            uploads: newItems.map(item=>item.f)
        })
        let rest = new Rest(this) 
        rest.request('update_uploads_position', "POST", {ids: newItems.map(i=>i.id)}, (res)=>{ 

        }) 
    }

    _render_upload = (f, index)=>{
        switch (this.props.display_type) {
            case 'list':
                return this._render_as_file(f, index)
                break;
        
            default:
                if(f.mimetype.indexOf('image')!=-1){ 
                    return (
                        this._render_as_image(f, index)
                    )
                }else{
                    return(
                        this._render_as_file(f, index)
                    )
                }
            break;
        } 
    }

    _render_sortable = ()=>{
        
        return( <RLDD
            items={this.state.uploads.map((f, index)=>{
                return {
                    id: f.id,
                    content: this._render_upload(f, index),
                    f: f
                }
            })}
            itemRenderer={(item) => {
              return (
                <div className="item border border-secondary p-2 m-1 pointer ">{item.content}</div>
              );
            }}
            onChange={this.handleRLDDChange}
          />
        )
    }

  render() {
    //console.log(this.state)
    var f = false
    if(this.state.queue.length>0){
        f = this.state.queue[0]
    }
    var max = this.props.max || 1

      

    return (
      <div className="m-3">  

            {
                this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
            }
          <div>{this.props.label} {this.props.max? " (maximum "+this.props.max+")" : null } </div>
            {
                !this.props.readonly && max>this.state.uploads.length?
                        
                <input  
                    onChange={e => this.addToUpload(e.currentTarget.files)} 
                    multiple="multiple" 
                    type="file"
                    accept={this.props.accept}
                />
                : null
            }
            {this.state.queue.length>0 && max>this.state.uploads.length && <div>
                Loading queue: {this.state.queue.length}
            </div>}
            {
                this.state.loading_file && <DirectUpload
                    file={this.state.loading_file} 
                    onSuccess={this.onSuccess}
                    variant={this.props.variant}
                    name={this.props.name}
                    description={this.props.description}
                    table_name={this.props.table_name} 
                    record_id={this.props.record_id}
                /> 
            } 
            
            { 
                this.props.sortable && 
                    <div>
                        {this._render_sortable()}
                    </div>
            }
            
            {
                !this.props.sortable && this.state.uploads.map((f, index)=>{
                    return this._render_upload(f, index)
                })
            }  
      
     </div>
    );
  }
}


Uploads.propTypes = {
    display_type: PropTypes.string,
    label: PropTypes.string,
    max: PropTypes.integer,
    readonly: PropTypes.bool,
    base64: PropTypes.bool,
    variant: PropTypes.string,
    description: PropTypes.string,
    table_name: PropTypes.string,
    name: PropTypes.string,
    record_id: PropTypes.integer,
    accept: PropTypes.string,
    returnUploads: PropTypes.func,
    sortable: PropTypes.bool
}